module.exports = __webpack_public_path__ + "img/ensolarado.6d081c80.png";